import {
    fetchSubmissionFailure,
    fetchSubmissionRequest,
    fetchSubmissionSuccess,
    deleteSubmissionRequest,
    deleteSubmissionSuccess,
    deleteSubmissionFailure,
    fetchSubmissionsForChallengeRequest,
    fetchSubmissionsForChallengeFailure,
    fetchSubmissionsForChallengeSuccess,
    fetchSubmissionsFailure,
    fetchSubmissionsRequest,
    fetchSubmissionsSuccess,
} from '@actions/submissions';

import { createReducer, PayloadAction } from '@reduxjs/toolkit';
import { convertArrToObj } from 'lib/src/utils/generic';
import { Submission } from 'src/types/shared/Assessments';
import {
    fetchCompleteSubmissionsForChallengeFailure,
    fetchCompleteSubmissionsForChallengeRequest,
    fetchCompleteSubmissionsForChallengeSuccess,
} from '@actions/submissions/fetchCompleteSubmissionsForChallenge';

interface SubmissionsState {
    isFetching: boolean;
    fetchError: string | null;
    isDeleting: boolean;
    deleteSuccess: boolean;
    deleteError: string | null;
    submissions: Record<number, Submission>;
}

const initialState: SubmissionsState = {
    isFetching: false,
    fetchError: null,
    isDeleting: false,
    deleteSuccess: false,
    deleteError: null,
    submissions: {},
};

export default createReducer(initialState, {
    [fetchSubmissionRequest.type]: handleFetchRequest,
    [fetchSubmissionFailure.type]: handleFetchFailure,
    [fetchSubmissionSuccess.type]: handleFetchSubmissionSuccess,
    [fetchSubmissionsForChallengeRequest.type]: handleFetchRequest,
    [fetchSubmissionsForChallengeFailure.type]: handleFetchFailure,
    [fetchSubmissionsForChallengeSuccess.type]: handleFetchSubmissionsSuccess,
    [fetchCompleteSubmissionsForChallengeRequest.type]: handleFetchRequest,
    [fetchCompleteSubmissionsForChallengeFailure.type]: handleFetchFailure,
    [fetchCompleteSubmissionsForChallengeSuccess.type]: handleFetchSubmissionsSuccess,
    [fetchSubmissionsRequest.type]: handleFetchRequest,
    [fetchSubmissionsFailure.type]: handleFetchFailure,
    [fetchSubmissionsSuccess.type]: handleFetchSubmissionsSuccess,
    [deleteSubmissionRequest.type]: handleDeleteRequest,
    [deleteSubmissionSuccess.type]: handleDeleteSubmissionSuccess,
    [deleteSubmissionFailure.type]: handleDeleteFailure,
});

function handleFetchRequest(state: SubmissionsState) {
    state.fetchError = null;
    state.isFetching = true;
}

function handleFetchFailure(state: SubmissionsState, action: PayloadAction<string>) {
    state.fetchError = action.payload;
    state.isFetching = false;
}

function handleDeleteRequest(state: SubmissionsState) {
    state.deleteError = null;
    state.deleteSuccess = false;
    state.isDeleting = true;
}

function handleDeleteFailure(state: SubmissionsState, action: PayloadAction<string>) {
    state.deleteError = action.payload;
    state.deleteSuccess = false;
    state.isDeleting = false;
}

function handleFetchSubmissionSuccess(state: SubmissionsState, action: PayloadAction<Submission>) {
    state.submissions[action.payload.id] = action.payload;
    state.isFetching = false;
}

function handleFetchSubmissionsSuccess(
    state: SubmissionsState,
    action: PayloadAction<Submission[]>,
) {
    state.submissions = convertArrToObj(action.payload);
    state.isFetching = false;
}

function handleDeleteSubmissionSuccess(state: SubmissionsState, action: PayloadAction<number>) {
    state.isDeleting = false;
    state.deleteSuccess = true;
    delete state.submissions[action.payload];
}
